import styled from "styled-components";

export const MenuLists = styled.span`
  color: ${({ theme }) => theme.neutral.white};
  margin-left: 0.5rem;
`;
